/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { Box, IconButton } from "@mui/material";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import MembershipStatusModal from "../../Modals/membershipStatusModal";
import RejectReasonModal from "../../Modals/rejectReason";
import CustomPagination from "../../components/CustomPagination";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import StarIcon from "@mui/icons-material/Star";

const CustomerListPending = () => {
  const navigate = useNavigate();

  const label = { inputProps: { "aria-label": "Switch demo" } };

  const [expandedRowId, setExpandedRowId] = useState<number | null>(null);

  const rows = [
    {
      id: 1,
      email: "abdul@sample.com",
      memberType: "Single",
      createdDate: "18 - June - 2025 | 6:00PM",
    },
    {
      id: 2,
      email: "abdul@sample.com",
      memberType: "Duo",
      createdDate: "18 - June - 2025 | 6:00PM",
    },
    {
      id: 3,
      email: "abdul@sample.com",
      memberType: "Single",
      createdDate: "18 - June - 2025 | 6:00PM",
    },
    {
      id: 4,
      email: "abdul@sample.com",
      memberType: "Duo",
      createdDate: "18 - June - 2025 | 6:00PM",
    },
    {
      id: 5,
      email: "abdul@sample.com",
      memberType: "Single",
      createdDate: "18 - June - 2025 | 6:00PM",
    },
  ];

  const toggleExpand = (id: number) => {
    setExpandedRowId((prevId) => (prevId === id ? null : id));
  };

  const [open, setOpen] = useState(false);
  const handleCloseModal = () => {
    setOpen(false);
  };

  const [open1, setOpen1] = useState(false);
  const handleCloseModal1 = () => {
    setOpen1(false);
  };

  return (
    <>
      <div className="sorting_table cards table_cards">
        <div className="table_container">
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              tableLayout: "fixed",
            }}
          >
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Membership Type</th>
                <th>Created Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <React.Fragment key={row.id}>
                  <tr>
                    <td>
                      <div
                        className="user_block click_action"
                        onClick={() =>
                          navigate("/manage-customers/detail", {
                            state: {
                              status: "PENDING",
                              memberType: row.memberType,
                            },
                          })
                        }
                      >
                        <StarIcon />
                        <figure>
                          <img
                            src="/static/images/user_placeholder.png"
                            alt=""
                          />
                        </figure>
                        <p>
                          <b>Madelyn Dias</b>
                        </p>
                      </div>
                    </td>
                    <td>{row.email}</td>
                    <td>
                      {row.memberType}
                      {row.memberType === "Duo" && (
                        <IconButton
                          className="d_active"
                          onClick={(e) => {
                            e.stopPropagation(); // Prevents triggering parent navigation if added
                            toggleExpand(row.id);
                          }}
                          size="small"
                          style={{ verticalAlign: "middle", marginLeft: 4 }}
                        >
                          {expandedRowId === row.id ? (
                            <ArrowDropDownIcon
                              style={{ transform: "rotate(180deg)" }}
                            />
                          ) : (
                            <ArrowDropDownIcon />
                          )}
                        </IconButton>
                      )}
                    </td>
                    <td>{row.createdDate}</td>
                    <td>
                      <div className="table_actions v2">
                        <Box>
                          <IconButton
                            className="cancel_icon"
                            onClick={() => setOpen(true)}
                          >
                            <CancelIcon />
                          </IconButton>
                        </Box>
                        <Box>
                          <IconButton
                            className="accept_icon"
                            onClick={() => setOpen1(true)}
                          >
                            <CheckCircleIcon />
                          </IconButton>
                        </Box>
                      </div>
                    </td>
                  </tr>

                  {expandedRowId === row.id && (
                    <tr>
                      <td colSpan={5}>
                        <div className="expanded-content p_inline_0">
                          <table
                            style={{
                              width: "100%",
                              borderCollapse: "collapse",
                              tableLayout: "fixed",
                            }}
                          >
                            <tbody>
                              <tr>
                                <td>
                                  <div
                                    className="user_block click_action"
                                    onClick={() =>
                                      navigate("/manage-customers/detail")
                                    }
                                  >
                                    <figure>
                                      <img
                                        src="/static/images/profile_img.png"
                                        alt=""
                                      />
                                    </figure>
                                    <p>
                                      <b>Madelyn Dias</b>
                                    </p>
                                  </div>
                                </td>
                                <td>{row.email}</td>
                                <td>{row.memberType}</td>
                                <td>{row.createdDate}</td>
                                <td>
                                  <div className="table_actions v2">
                                    <Box>
                                      <IconButton
                                        className="cancel_icon"
                                        onClick={() => setOpen(true)}
                                      >
                                        <CancelIcon />
                                      </IconButton>
                                    </Box>
                                    <Box>
                                      <IconButton
                                        className="accept_icon"
                                        onClick={() => setOpen1(true)}
                                      >
                                        <CheckCircleIcon />
                                      </IconButton>
                                    </Box>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <CustomPagination />
      <RejectReasonModal
        open={open}
        onClose={handleCloseModal}
        setOpen={setOpen}
      />
      <MembershipStatusModal
        open={open1}
        onClose={handleCloseModal1}
        setOpen={setOpen1}
      />
    </>
  );
};

export default CustomerListPending;
